import useMediaQueries from '@stone/hooks/useMediaQueries';
import { useStoreServices } from '@stone/hooks/useStoresServices';
import React from 'react';
import { StorePageInnerSection } from './StoreSections';
import SwiperCore, { Navigation, A11y, Keyboard } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import Icon from '@stone/ui/icon/Icon';
import { useTranslation } from 'react-i18next';
import { useLangChecker } from '@common/utils/i18n';
SwiperCore.use([Keyboard, Navigation, A11y]);
const StoreServices = (props) => {
    const { isMobile } = useMediaQueries();
    const { t } = useTranslation();
    const services = useStoreServices(props.store);
    const swiperProps = {
        watchOverflow: true,
        slidesPerView: 6 / 5,
        spaceBetween: 12,
        navigation: {
            prevEl: '.services-navigation--prev',
            nextEl: '.services-navigation--next',
        },
    };
    const renderNavigation = () => (React.createElement("div", { className: "navigation" },
        React.createElement("button", { className: "button services-navigation--prev", "aria-label": t('carousel.prevslidemessage') },
            React.createElement(Icon, { name: "left-chevron", family: "10" })),
        React.createElement("button", { className: "button services-navigation--next", "aria-label": t('carousel.nextslidemessage') },
            React.createElement(Icon, { name: "right-chevron", family: "10" }))));
    const renderList = () => (React.createElement(React.Fragment, null, services.map((service, i) => (React.createElement(StorePageInnerSection, { title: (i + 1).toString().padStart(2, '0'), key: service.key, hasIndexes: true },
        React.createElement("h3", { className: "font__title service-title", ref: useLangChecker }, service.title),
        React.createElement("p", null, service.desc))))));
    const renderCarousel = () => (React.createElement(React.Fragment, null,
        renderNavigation(),
        React.createElement(Swiper, Object.assign({}, swiperProps), services.map((service, i) => (React.createElement(SwiperSlide, { key: `slide-service-${service.key}`, className: "store-page__services-slide" },
            React.createElement("p", { className: "font__title service-index" }, (i + 1).toString().padStart(2, '0')),
            React.createElement("p", { className: "font__title service-title" }, service.title),
            React.createElement("p", { className: "description" }, service.desc)))))));
    return React.createElement(React.Fragment, null, (services === null || services === void 0 ? void 0 : services.length) && React.createElement("div", { className: "store-page__services" }, isMobile ? renderCarousel() : renderList()));
};
export default StoreServices;
